import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Deviatoio } from '../models/models/pages/deviatoio';

@Injectable({ providedIn: 'root' })
export class DeviatoioService {
    private baseUrl = `${environment.baseApiUrl}/deviatoi-riepilogo-generale`;

    constructor(private http: HttpClient) {}

    list(params?: { page?: number; size?: number; sort?: string; filter?: string }): Observable<HttpResponse<Deviatoio[]>> {
        let httpParams = new HttpParams();
        if (params?.page != null) httpParams = httpParams.set('page', params.page);
        if (params?.size != null) httpParams = httpParams.set('size', params.size);
        if (params?.sort) httpParams = httpParams.set('sort', params.sort);
        if (params?.filter) httpParams = httpParams.set('filter', params.filter);


        return this.http.get<Deviatoio[]>(this.baseUrl, {
            params: httpParams,
            withCredentials: true,
            observe: 'response'
        });
    }

    // GET by id
    get(id: number): Observable<Deviatoio> {
        return this.http.get<Deviatoio>(`${this.baseUrl}/${id}`, { withCredentials: true });
    }

    // CREATE (POST)
    create(payload: Omit<Deviatoio, 'id'>): Observable<Deviatoio> {
        return this.http.post<Deviatoio>(this.baseUrl, payload, { withCredentials: true });
    }

    // UPDATE completo (PUT) - id nel path e nel body devono coincidere
    update(entity: Deviatoio): Observable<Deviatoio> {
        return this.http.put<Deviatoio>(`${this.baseUrl}/${entity.id}`, entity, { withCredentials: true });
    }

    // PATCH parziale (solo i campi che cambi)
    partialUpdate(id: number, patch: Partial<Deviatoio>): Observable<Deviatoio> {
        const headers = new HttpHeaders({ 'Content-Type': 'application/merge-patch+json' });
        return this.http.patch<Deviatoio>(`${this.baseUrl}/${id}`, patch, {
            headers,
            withCredentials: true
        });
    }

    delete(id: number): Observable<void> {
        return this.http.delete<void>(`${this.baseUrl}/${id}`, { withCredentials: true });
    }

    findOne(id: number) {
        return this.http.get<Deviatoio>(`${this.baseUrl}/${id}`, { withCredentials: true });
    }

    // --- LOOKUP per le select ---
    getCuore(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.baseApiUrl}/deviatoi-cuore`, { withCredentials: true });
    }

    getDeviaTra(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.baseApiUrl}/deviatoi-devia-tra`, { withCredentials: true });
    }

    getLunghezzaAghi(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.baseApiUrl}/deviatoi-lunghezza-aghi`, { withCredentials: true });
    }

    getLunghezza(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.baseApiUrl}/deviatoi-lunghezza`, { withCredentials: true });
    }

    getManovra(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.baseApiUrl}/deviatoi-manovra`, { withCredentials: true });
    }

    getMovimentoAghi(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.baseApiUrl}/deviatoi-movimento-aghi`, { withCredentials: true });
    }

    getSchedaInterventi(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.baseApiUrl}/deviatoio-scheda-interventi`, { withCredentials: true });
    }

    getTipologia(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.baseApiUrl}/deviatoio-tipologia`, { withCredentials: true });
    }

    getTiranteria(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.baseApiUrl}/deviatoio-tiranteria`, { withCredentials: true });
    }

    getPosa(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.baseApiUrl}/deviatoi-posa`, { withCredentials: true });
    }

    getRaggio(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.baseApiUrl}/deviatoi-raggio`, { withCredentials: true });
    }

    getRiepilogoGenerale(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.baseApiUrl}/deviatoi-riepilogo-generale`, { withCredentials: true });
    }

    getTangente(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.baseApiUrl}/deviatoi-tangente`, { withCredentials: true });
    }

    getTelaioInglese(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.baseApiUrl}/deviatoi-telaio-inglese`, { withCredentials: true });
    }

    getVisuale(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.baseApiUrl}/deviatoi-visuale`, { withCredentials: true });
    }

    getLineaAppartenenza(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.baseApiUrl}/linea-appartenenza`, { withCredentials: true });
    }

    getParcoAppartenenza(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.baseApiUrl}/parco-appartenenza`, { withCredentials: true });
    }

    getBinarioAppartenenza(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.baseApiUrl}/binario-appartenenza`, { withCredentials: true });
    }

    getDeviatoiDeviaTra(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.baseApiUrl}/deviatoi-devia-tra`, { withCredentials: true });
    }

    getSpecificaParco(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.baseApiUrl}/specifica-parco`, { withCredentials: true });
    }

    getProprieta(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.baseApiUrl}/proprieta`, { withCredentials: true });
    }

    getSedime(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.baseApiUrl}/sedime`, { withCredentials: true });
    }
}
